import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControlLabel, Grid, Paper, Snackbar, Switch, TextField, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import DialogInfo from "pages/components/DialogInfo";
import DialogQuest from "pages/components/DialogQuest";
import ColoredLinearProgress from "pages/components/LineProgress";
import Home from "pages/home";
import copy from 'copy-to-clipboard';
import { getMirrorHints, isValidIngestKey, MIRROR_HELP } from "./mirrorHints";

// Actions
import { Creators } from "store/ducks/clients";

//style ustilizado
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },

  user: {
    display: "flex",
    flexDirection: "column",
    width: 300,
    height: "auto",
  },
}));

const Index = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { pending, clients, modified, feedback } = useSelector((state) => state.clients);
  const [questionOpened, setQuestionOpened] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editAdd, setAddOpened] = useState(false);
  const [infoOpened, setInfoOpened] = useState(false);
  const [name, setName] = useState("");
  const [provider, setProvider] = useState("");
  const [doc, setDoc] = useState("");
  const [mirrorOrders, setMirrorOrders] = useState(false);
  const [mirrorEvents, setMirrorEvents] = useState(false);
  // chave de ingestão V2 (write-only): só vive no diálogo, é zerada ao fechar/enviar
  const [keyTarget, setKeyTarget] = useState(null);
  const [keyInput, setKeyInput] = useState("");
  const [keyTouched, setKeyTouched] = useState(false);
  const [clearTarget, setClearTarget] = useState(null);

  const onQuestionClose = () => setQuestionOpened(false);

  useEffect(() => {
    dispatch(Creators.fetchClients());
  }, []);

  useEffect(() => {
    if(modified === true){
      dispatch(Creators.fetchClients());
    }
  }, [modified]);

  //criar novos clients -> ação
  const onAddPress = (e) => {
    e.preventDefault();

    if(name.trim().length < 3) return
    if(doc.trim().length < 11 ) return

    const _provider = String(provider).replace(/ /g, "-").toLowerCase();
    dispatch(Creators.postClient({
      name, doc, provider:_provider,
      v2_mirror_orders: mirrorOrders,
      v2_mirror_events: mirrorEvents,
    }));
    setAddOpened(false);
    setMirrorOrders(false);
    setMirrorEvents(false);
  };

  //criar novos clients -> dialogo
  const onQuestionAddClose = () => {
    setAddOpened(false);
    setName("");
    setDoc("");
    setMirrorOrders(false);
    setMirrorEvents(false);
  };

  // espelhamento -> interruptor (otimista; a saga reverte em erro)
  const handleToggle = (row, field, value) => {
    dispatch(Creators.updateClient(row.id, { [field]: value }, { [field]: row[field] === true }));
  };

  // chave de ingestão V2 -> diálogo (write-only)
  const closeKeyDialog = () => {
    setKeyTarget(null);
    setKeyInput("");
    setKeyTouched(false);
  };
  const keyInvalid = keyTouched && !isValidIngestKey(keyInput);
  const onKeySubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setKeyTouched(true);
    if (!keyTarget || !isValidIngestKey(keyInput)) return;
    dispatch(Creators.updateClient(
      keyTarget.id,
      { v2_ingest_key_set: true },
      { v2_ingest_key_set: keyTarget.v2_ingest_key_set === true },
      keyInput,
    ));
    closeKeyDialog();
  };
  const onKeyClear = () => {
    if (clearTarget) {
      dispatch(Creators.updateClient(
        clearTarget.id,
        { v2_ingest_key_set: false },
        { v2_ingest_key_set: clearTarget.v2_ingest_key_set === true },
        "",
      ));
    }
    setClearTarget(null);
  };

  //criar novos clients -> dialogo
  const handleAdd = (params) => {
    setAddOpened(true);
  };

  //copy datato clipboard
  const handleCopy = (params) => {
    const { row } = params;
    const { id, name, cpf_cnpj, token_prod, token_staging } = row;
    const text = `id: ${id}\nnome: ${name}\ndoc: ${cpf_cnpj}\nToken Prod: ${token_prod}\nToken Staging: ${token_staging}`;
    copy(text);
  };

  //remover clients -> dialogo
  const handleDelete = (params) => {
    const ITEM = clients.find((v) => v.id === params.row.id);
    setSelectedItem(ITEM);
    //abre o dialogo que confirma exclusão
    setQuestionOpened(true);
  };
  //remover clients -> ação
  const onDeletePress = (params) => {
    dispatch(Creators.deleteClient(selectedItem?.id));
    setQuestionOpened(false);
  };

  const columns = [
    { field: "id", headerName: "Id" },
    { field: "name", headerName: "Nome", width: 200 },
    { field: "provider", headerName: "Provider", width: 200 },
    { field: "cpf_cnpj", headerName: "CPF/CNPJ", width: 200 },
    { field: "token_prod", headerName: "Token Prod", width: 200 },
    { field: "token_staging", headerName: "Token Staging", width: 200 },
    {
      field: "v2_mirror_orders",
      headerName: "Espelhamento de Pedidos V1 » V2",
      width: 230,
      sortable: false,
      renderCell: (params) => (
        <Switch
          color="primary"
          checked={params.row.v2_mirror_orders === true}
          onChange={(e) => handleToggle(params.row, "v2_mirror_orders", e.target.checked)}
          inputProps={{ "aria-label": `Espelhamento de Pedidos V1 » V2 de ${params.row.name}` }}
        />
      ),
    },
    {
      field: "v2_mirror_events",
      headerName: "Espelhamento de Ocorrências V1 » V2",
      width: 250,
      sortable: false,
      renderCell: (params) => (
        <Switch
          color="primary"
          checked={params.row.v2_mirror_events === true}
          onChange={(e) => handleToggle(params.row, "v2_mirror_events", e.target.checked)}
          inputProps={{ "aria-label": `Espelhamento de Ocorrências V1 » V2 de ${params.row.name}` }}
        />
      ),
    },
    {
      field: "v2_ingest_key_set",
      headerName: "Chave de ingestão V2",
      width: 260,
      sortable: false,
      renderCell: (params) => (
        <>
          <span style={{ minWidth: 90 }}>
            {params.row.v2_ingest_key_set === true ? "definida" : "não definida"}
          </span>
          <Button
            size="small"
            type="button"
            variant="outlined"
            style={{ marginLeft: 8 }}
            onClick={() => setKeyTarget(params.row)}
          >
            {params.row.v2_ingest_key_set === true ? "Trocar" : "Definir"}
          </Button>
          {params.row.v2_ingest_key_set === true ? (
            <Button
              size="small"
              type="button"
              variant="outlined"
              style={{ marginLeft: 8 }}
              onClick={() => setClearTarget(params.row)}
            >
              Limpar
            </Button>
          ) : null}
        </>
      ),
    },
    {
      field: "v2_hints",
      headerName: "Avisos do espelhamento",
      width: 380,
      sortable: false,
      renderCell: (params) => {
        const hints = getMirrorHints(params.row);
        return (
          <div title={hints.join("\n")} style={{ whiteSpace: "normal", lineHeight: 1.2, fontSize: 11, color: "#b26a00" }}>
            {hints.map((h) => <div key={h}>{h}</div>)}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Ações",
      width: 200,
      renderCell: (params) => (
        <>
          {clients ? (
            <>
              <Button
                size="small"
                type="button"
                variant="contained"
                color="secondary"
                style={{ marginLeft: 8 }}
                onClick={() => handleDelete(params)}
              >
                Remover
              </Button>

              <Button
                size="small"
                type="button"
                variant="contained"
                color="default"
                style={{ marginLeft: 8 }}
                onClick={() => handleCopy(params)}
              >
                Copiar
              </Button>
            </>
          ) : (
            <>
            </>
          )}
        </>
      ),
    },
  ];

  return (
    <Home title={"Clientes e Tokens"}>
      {pending ? <ColoredLinearProgress /> : null}
      <br />
      <Button
        size="small"
        type="button"
        variant="contained"
        color="default"
        style={{ float: "right" }}
        onClick={() => handleAdd()}
      >
        Adicionar
      </Button>

      <Typography variant="caption" color="textSecondary">
        Interruptores de espelhamento V1 » V2 por cliente. {MIRROR_HELP}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <DataGrid
              rows={clients}
              columns={columns}
              density="comfortable"
              rowHeight={84}
              autoHeight={true}
              autoPageSize={true}
              disableColumnMenu={true}
              hideFooterSelectedRowCount={true}
            />
          </Paper>
        </Grid>
      </Grid>

      {editAdd ? (
        <DialogQuest
          title={"Novo Cliente"}
          fullWidth
          onConfirm={onAddPress}
          confirmLabel={"SALVAR"}
          opened={editAdd}
          onClose={onQuestionAddClose}
        >
          {pending ? "Aguarde..." : ""}
          <div className={classes.add}>
            <TextField
              disabled={pending}
              value={name}
              onChange={(e) => setName(e.target.value)}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="name"
              label="Nome"
              name="name"
              autoFocus
            />

            <TextField
              disabled={pending}
              value={provider}
              onChange={(e) => setProvider(e.target.value)}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="provider"
              label="Provider"
              name="provider"
              autoFocus
            />

            <TextField
              disabled={pending}
              value={doc}
              onChange={(e) => setDoc(e.target.value)}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="doc"
              label="CPF/CNPJ"
              name="doc"
              autoFocus
              type="doc"
            />

            <FormControlLabel
              control={<Switch color="primary" checked={mirrorOrders} onChange={(e) => setMirrorOrders(e.target.checked)} />}
              label="Espelhamento de Pedidos V1 » V2"
            />
            <br />
            <FormControlLabel
              control={<Switch color="primary" checked={mirrorEvents} onChange={(e) => setMirrorEvents(e.target.checked)} />}
              label="Espelhamento de Ocorrências V1 » V2"
            />
            <br />
            <Typography variant="caption" color="textSecondary">
              Desligados por padrão. A chave de ingestão V2 é definida depois, na lista.
            </Typography>
          </div>
        </DialogQuest>
      ) : null}

      {keyTarget ? (
        <DialogQuest
          title={`Chave de ingestão V2 — ${keyTarget.name}`}
          message="A chave é somente escrita: depois de enviada, não é exibida nem guardada nesta tela."
          onConfirm={onKeySubmit}
          confirmLabel={"SALVAR CHAVE"}
          opened={!!keyTarget}
          onClose={closeKeyDialog}
        >
          <TextField
            value={keyInput}
            onChange={(e) => setKeyInput(e.target.value.trim())}
            onBlur={() => setKeyTouched(true)}
            variant="outlined"
            margin="normal"
            fullWidth
            autoFocus
            type="password"
            autoComplete="new-password"
            placeholder="vnx_live_…"
            label="Chave de ingestão V2"
            error={keyInvalid}
            helperText={keyInvalid ? "Formato inválido. Esperado: vnx_live_ seguido de 16+ letras, números ou _" : " "}
          />
        </DialogQuest>
      ) : null}

      {clearTarget ? (
        <DialogQuest
          title={"Limpar chave de ingestão V2?"}
          message={`O espelhamento de ${clearTarget.name} deixará de entregar na V2 até uma nova chave ser definida.`}
          onConfirm={onKeyClear}
          confirmLabel={"LIMPAR CHAVE"}
          opened={!!clearTarget}
          onClose={() => setClearTarget(null)}
        />
      ) : null}

      <Snackbar
        open={!!feedback}
        autoHideDuration={5000}
        onClose={() => dispatch(Creators.clearClientFeedback())}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {feedback ? (
          <Alert severity={feedback.type} onClose={() => dispatch(Creators.clearClientFeedback())}>
            {feedback.message}
          </Alert>
        ) : <span />}
      </Snackbar>
      {infoOpened ? (
        <DialogInfo
          title={"Mensagem"}
          message={"Necessário preencher todos os campos!"}
          opened={infoOpened}
          onClose={() => setInfoOpened(false)}
        />
      ) : null}

      {questionOpened ? (
        <DialogQuest
          title={"Tem certeza?"}
          message={"Essa ação não poderá ser desfeita!"}
          onConfirm={onDeletePress}
          confirmLabel={"REMOVER CLIENTE"}
          opened={questionOpened}
          onClose={onQuestionClose}
        />
      ) : null}
    </Home>
  );
};

export default Index;
